/// <reference path="../types.d.ts" />
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { putContext } from './contexts.action';
import { loading, navigateContext } from './ui';
import { cmxLocation, HttpMethods, commonActions } from '@codametrix/ui-common';
const { Eula } = commonActions;
const saveEula = createAction(Eula.SAVE_EULA);
const cancelEula = createAction(Eula.CANCEL_EULA, (value)=>({
        payload: value,
        meta: {
            analytics: true
        }
    }));
const acceptInitial = createAction(Eula.ACCEPT_INIT, (value)=>({
        payload: value,
        meta: {
            analytics: true
        }
    }));
const getEula = async (userId, orgId)=>{
    const eula = await api({
        endpoint: `/users/eula/v1?userId=${userId}&orgId=${orgId}`
    });
    return {
        ...eula
    };
};
const acceptEula = createAsyncThunk(Eula.ACCEPT_EULA, async (payload, { dispatch, getState, rejectWithValue })=>{
    dispatch(acceptInitial(payload.eula));
    const user = await api({
        endpoint: '/users/eula/v1',
        init: {
            method: HttpMethods.POST
        },
        body: payload.eula
    });
    dispatch(saveEula(payload.eula));
    if (payload.context.activeContext?.organizationId) {
        const freshContext = await putContext({
            organizationId: payload.context.activeContext?.organizationId.toString()
        }, dispatch);
        cmxLocation.resetLocation();
        dispatch(loading(false));
        await dispatch(navigateContext({
            context: freshContext,
            homepagePreference: payload.homepagePreference
        }));
    } else {
        cmxLocation.resetLocation();
    }
    return user;
});
export { getEula, saveEula, acceptEula, cancelEula };
